module.exports = __webpack_public_path__ + "icons_06.74f8480d.svg";